import { serviceIcon } from './serviceIcons';
import './ServiceSelector.css';

export function ServiceSelector({ services, selectedServiceId, onSelect }) {
  return (
    <div className="service-selector" role="radiogroup">
      {services.map((service) => {
        const Icon = serviceIcon(service.iconName);
        const isSelected = selectedServiceId === service.serviceId;

        return (
          <button
            key={service.serviceId}
            type="button"
            role="radio"
            aria-checked={isSelected}
            onClick={() => onSelect(service.serviceId)}
            className={`service-selector__option${
              isSelected ? ' service-selector__option--selected' : ''
            }`}
          >
            <div className="service-selector__body">
              <div className="service-selector__icon">
                <Icon size={20} />
              </div>
              <div className="service-selector__content">
                <div className="service-selector__head">
                  <h4 className="service-selector__title">{service.serviceName}</h4>
                  <input
                    type="radio"
                    checked={isSelected}
                    onChange={() => {}}
                    tabIndex={-1}
                    aria-hidden="true"
                    className="service-selector__radio"
                  />
                </div>
                <p className="service-selector__description">{service.description}</p>
                <div className="service-selector__meta">
                  {service.standardPrice > 0 ? (
                    <span className="service-selector__price">from €{service.standardPrice}</span>
                  ) : (
                    <span className="service-selector__price service-selector__price--absent">
                      Contact for price
                    </span>
                  )}
                  <span className="service-selector__hours">• ~{service.requiredHours}h</span>
                </div>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
